export enum StatusType {
  SUCCESS = 'success',
  ERROR = 'error',
  NEUTRAL = 'neutral',
  LOADING = 'loading',
  PENDING = 'pending',
}
